import React, {useEffect, useState} from 'react';
import { Link, useNavigate } from 'react-router-dom';

import getNavLinks from './nav-links'

async function getUserSubscription() {
    const response = await fetch('/api/get-account-subscription', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        const subscription = await response.json();
        return subscription;
    } else {
        return false;
    }
}

async function getUserData() {
    const response = await fetch('/api/get-account-data', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        const user_data = await response.json();
        return user_data;
    } else {
        return false;
    }
}

async function getUserNotifications() {  
    if (document.hidden) return;

    const response = await fetch('/api/get-account-notifications', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    const data = await response.json();

    if (response.ok) {
        return data;
    } else {
        return false;
    }
}

const logout = async (navigate) => {
    const response = await fetch("/api/logout", {
        method: "POST",
        credentials: "include"
    });

    if (response.ok) {
        navigate('/');
    }
}

function LeftHeader({isUserLogged, setIsUserLogged, currentPage}) {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);
    const [userSubscription, setUserSubscription] = useState("free")
    const [userName, setUserName] = useState("")

    const [userNotifications, setUserNotifications] = useState(false)

    const navLinks = getNavLinks()

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

    const getAndSetUserNotifications = async () => {
        setUserNotifications(await getUserNotifications())
    };

    useEffect(() => {
        if (isUserLogged) {
            async function fetchData() {
                setUserSubscription(await getUserSubscription());
                const userData = await getUserData()
                setUserName(userData.name + " " + userData.surname)
            }

            fetchData()
        }
    }, [isUserLogged])

    useEffect(() => {
        const interval = setInterval(async () => {
            await getAndSetUserNotifications();
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    const handleLogout = () => {
        logout(navigate);
        setIsUserLogged(false)
    };


    return (
        <header className="sticky top-0 z-50 w-full border-b border-border-color bg-background-dark/80 backdrop-blur-md px-6 lg:px-20 py-3">
            <div className="max-w-[1440px] mx-auto flex items-center justify-between">
                <div className="flex items-center gap-8">
                    <Link to="/">
                        <div className="flex items-center gap-3">
                            <div className="size-8 bg-primary rounded flex items-center justify-center">
                                <span className="material-symbols-outlined text-white text-xl">speed</span>
                            </div>
                            <h1 className="text-xl font-bold tracking-tight text-white uppercase italic"><span className="text-primary">Live</span>Telemetry</h1>
                        </div>
                    </Link>

                    <nav className="hidden md:flex items-center gap-6">
                        {navLinks.map((item) => (
                            <Link key={item.link} to={item.link}>
                                <button className={`${currentPage === item.text ? "text-primary" : "text-slate-300"} text-sm font-medium hover:text-primary transition-colors`}>{item.text}</button>
                            </Link>
                        ))}
                    </nav>
                </div>
                <div className="flex items-center gap-4">
                    {isUserLogged === true ? (
                        <div className="relative group">
                            <div className="size-10 rounded-full bg-[#233648] border border-[#324d67] flex items-center justify-center cursor-pointer" onClick={toggleVisibility}>
                                <span className="material-symbols-outlined">person</span>
                            </div>

                            <div className={`absolute top-full right-0 mt-3 w-64 bg-[#111a22] border border-[#324d67] rounded-lg shadow-2xl dropdown-glow z-[60] overflow-hidden ${isVisible ? 'visible' : 'invisible'}`}>
                                <div className="p-4 bg-gradient-to-b from-[#1a2b3c] to-transparent border-b border-[#324d67]/50">
                                    <div className="flex items-center gap-3">
                                        <div className="size-10 rounded bg-primary/20 border border-primary/30 flex items-center justify-center">
                                            <span className="material-symbols-outlined text-primary">person</span>
                                        </div>
                                        <div className="flex flex-col">
                                            <span className="text-sm font-bold text-white tracking-tight uppercase">{userName}</span>
                                            <span className="text-[10px] font-bold text-acc-cyan uppercase tracking-widest">{userSubscription}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-1.5">
                                    <Link to="/dashboard">
                                        <p className="flex items-center gap-3 px-3 py-2.5 rounded text-[#92adc9] hover:text-white hover:bg-primary/10 transition-colors group/item max-h-[40px]">
                                            <span className="material-symbols-outlined text-lg group-hover/item:text-primary">dashboard</span>
                                            <span className="text-xs font-bold uppercase tracking-wide">Dashboard</span>
                                        </p>
                                    </Link>

                                    <Link to="/account-settings">
                                        <p className="flex items-center gap-3 px-3 py-2.5 rounded text-[#92adc9] hover:text-white hover:bg-primary/10 transition-colors group/item max-h-[40px]">
                                            <span className="material-symbols-outlined text-lg group-hover/item:text-primary">settings</span>
                                            <span className="text-xs font-bold uppercase tracking-wide">Account Settings</span>
                                        </p>
                                    </Link>
                
                                    {userSubscription === "free" &&
                                        <Link to="/subscription-plans">
                                            <p className="flex items-center gap-3 px-3 py-2.5 rounded text-[#92adc9] hover:text-white hover:bg-primary/10 transition-colors group/item max-h-[40px]">
                                                <span className="material-symbols-outlined text-lg group-hover/item:text-primary">workspace_premium</span>
                                                <span className="text-xs font-bold uppercase tracking-wide">Subscription Plan</span>
                                            </p>
                                        </Link>
                                    }

                                    <Link to="/friends">
                                        <p className="flex relative items-center gap-3 px-3 py-2.5 rounded text-[#92adc9] hover:text-white hover:bg-primary/10 transition-colors group/item max-h-[40px]">
                                            <span className="material-symbols-outlined text-lg group-hover/item:text-primary">person</span>
                                            <span className="text-xs font-bold uppercase tracking-wide">Friends</span>

                                            {userNotifications && (
                                                <span className="absolute top-2.5 left-[23px] flex h-2 w-2">
                                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-racing-red opacity-75"></span>
                                                    <span className="relative inline-flex rounded-full h-2 w-2 bg-acc-red"></span>
                                                </span>
                                            )}
                                        </p>
                                    </Link>

                                    <Link to="/sessions">
                                        <p className="flex items-center gap-3 px-3 py-2.5 rounded text-[#92adc9] hover:text-white hover:bg-primary/10 transition-colors group/item max-h-[40px]">
                                            <span className="material-symbols-outlined text-lg group-hover/item:text-primary">database</span>
                                            <span className="text-xs font-bold uppercase tracking-wide">Sessions</span>
                                        </p>
                                    </Link>
                
                                    <div className="h-px bg-[#233648] mt-[10px] mb-[10px]"></div>
                
                                    <p onClick={handleLogout} className="flex items-center gap-3 px-3 py-2.5 rounded text-acc-red hover:bg-acc-red/10 transition-colors group/item max-h-[40px] cursor-pointer">
                                        <span className="material-symbols-outlined text-lg">logout</span>
                                        <span className="text-xs font-bold uppercase tracking-wide">Logout</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="flex items-center gap-4">
                            <button className="text-sm font-bold text-white px-4 py-2 hover:text-primary transition-colors"><Link to="/login">Login</Link></button>
                            <Link to="/signup"><button className="bg-primary hover:bg-primary/90 text-white text-sm font-bold px-5 py-2 rounded-lg transition-all glow-blue">Get Started</button></Link>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
}

export default LeftHeader;